import { createContext } from 'react';

import type { API_UserGroupDetailResponse, User } from '~/data/schemas/user';

export type Locale = 'en-GB' | 'en-US';

export type UserData = {
  user: { email?: string; id: string };
  userGroup: API_UserGroupDetailResponse | null;
  currencyCode: 'GBP' | 'USD';
  locale: Locale;
  userDetails: User;
};

export const UserContext = createContext<UserData>({
  user: { email: '', id: '' },
  userGroup: null,
  currencyCode: 'USD',
  locale: 'en-US',
  userDetails: {
    id: '',
    fullName: '',
    email: '',
    phoneNumber: '',
    role: 'none',
    isLiftaiAdmin: false,
    username: 'test-user',
    consultantGroup: null,
    clientGroup: null,
    isGroupAdmin: false,
  },
});
